import styles from './user-reg-wrapper.module.scss';
import { BREAKPOINT_SIZES, BREAKPOINTS } from 'tradera/constants/breakpoints';
import MediaQuery from 'react-responsive';

export const UserRegWrapper = ({ children }) => {
    return (
        <div className={`${styles.userRegWrapper}`}>
            <MediaQuery minWidth={BREAKPOINT_SIZES[BREAKPOINTS.MD].min}>
                <div className={styles.userRegWrapperImage}>
                    <img
                        src="/static/images/circular/blandadeklader.jpg"
                        alt=""
                    />
                </div>
            </MediaQuery>
            <div
                className={`bg-white ${styles.userRegContent} blocking-loader-container`}>
                {children}
            </div>
        </div>
    );
};
